unit ManualEntryList;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Lists,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.WebCtrls,
  XData.Web.Client,
  smx.webcore.types, WEBLib.Country;

type
  TManualEntryListForm = class(TBaseListForm)
    RefreshTimer: TTimer;
    TitleEdit: TDBEdit;
    FirstNameEdit: TDBEdit;
    LastNameEdit: TDBEdit;
    Add1Edit: TDBEdit;
    Add2Edit: TDBEdit;
    Add3Edit: TDBEdit;
    DateAddedEdit: TDBDateTimePicker;
    PostCodeEdit: TDBEdit;
    AmountEdit: TDBEdit;
    SponsoredEdit: TDBCheckBox;
    CityEdit: TDBEdit;
    WaitForBatchIdTimer: TTimer;
    MergeButton: TButton;
    WaitForBatchDataTimer: TTimer;
    DonationsData: TLabel;
    ClearButton: TButton;
    NextRecordTimer: TTimer;
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetTitle: TStringField;
    MainDatasetFirstName: TStringField;
    MainDatasetMiddleName: TStringField;
    MainDatasetLastName: TStringField;
    MainDatasetSuffix: TStringField;
    MainDatasetAdd1: TStringField;
    MainDatasetAdd2: TStringField;
    MainDatasetAdd3: TStringField;
    MainDatasetCity: TStringField;
    MainDatasetPostCode: TStringField;
    MainDatasetEmail: TStringField;
    MainDatasetMobile: TStringField;
    MainDatasetTelephone: TStringField;
    MainDatasetMatchHash: TStringField;
    MainDatasetContactByPhone: TBooleanField;
    MainDatasetContactByPost: TBooleanField;
    MainDatasetContactByText: TBooleanField;
    MainDatasetContactByEmail: TBooleanField;
    MainDatasetDOB: TDateField;
    MainDatasetHearingStatus: TStringField;
    MainDatasetEmailStatus: TStringField;
    MainDatasetLatitude: TFloatField;
    MainDatasetLongitude: TFloatField;
    MainDatasetExternalId: TStringField;
    MainDatasetCountryCode: TStringField;
    MainDatasetVisualStatus: TStringField;
    MainDatasetMobilityStatus: TStringField;
    MainDatasetSourceType: TStringField;
    MainDatasetClaimStatus: TStringField;
    MainDatasetCharityTenant: TStringField;
    MainDatasetImportState: TStringField;
    MainDatasetErrorText: TStringField;
    MainDatasetImportBatchId: TIntegerField;
    MainDatasetSponsored: TBooleanField;
    MainDatasetDonationDate: TDateTimeField;
    MainDatasetGiftAid: TFloatField;
    MainDatasetAmount: TFloatField;
    MainDatasetExternalDonationId: TStringField;
    MainDatasetExternalDonationId2: TStringField;
    MainDatasetMatchedPerson: TIntegerField;
    MessageDialog: TMessageDlg;
    DuplicateDialog: TMessageDlg;
    CountryList: TCountryComboBox;
    ErrorMessageTransactionDate: TLabel;
    EnableSaveButtonTimer: TTimer;
    DeleteDonation: TMessageDlg;
    DeleteDonor: TMessageDlg;
    procedure AddButtonClick(Sender: TObject);
    procedure AmountEditKeyPress(Sender: TObject; var Key: Char);
    procedure DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure MainDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure MainDatasetAfterOpen(DataSet: TDataSet);
    procedure MergeButtonClick(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
    procedure RefreshTimerTimer(Sender: TObject);
    procedure SaveDonationClick(Sender: TObject);
    procedure WaitForBatchDataTimerTimer(Sender: TObject);
    procedure WaitForBatchIdTimerTimer(Sender: TObject);
    procedure ClearButtonClick(Sender: TObject);
    procedure CountryListChange(Sender: TObject);
    procedure CountryListExit(Sender: TObject);
    procedure DateAddedEditChange(Sender: TObject);
    procedure MainDatasetAfterDelete(DataSet: TDataSet);
    procedure NextRecordTimerTimer(Sender: TObject);
    procedure PostCodeEditExit(Sender: TObject);
    procedure EditExit(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure EnableSaveButtonTimerTimer(Sender: TObject);
    procedure PostCodeEditChange(Sender: TObject);
  private
    { Private declarations }
    FDateTimePrevious: TDateTime;

    FBatchId: Integer;
    FBatchTotal: Currency;
    FNoOfDonations: Integer;
    FNoOfErrors: Integer;
    FMergeEnabled: boolean;

    FPostCodeValid: boolean;
    FDateAddedValid: boolean;
    FIsDuplicate: boolean;
    [async]
    procedure RefreshData; async;
    [async]
    procedure GetNewBatchId; async;
    [async]
    procedure RefreshBatchData; async;

    procedure SaveNewDonation;
    procedure SaveNewDonationWithBatchId;
    [async]
    procedure MergeDataJob; async;
    procedure ValidatePostCode;
    procedure CheckValidation;
    procedure UnLockControls(const AUnLock: Boolean); override;

    [async]
    procedure CheckForDuplicates; async;
    [async]
    procedure CheckEnableSaveButton; async;
    procedure ValidateDate;
    [async]
    procedure CheckForOpenManualBatches; async;
    procedure SetRequiredPostCode(ARequired: boolean);

  protected
    procedure DeleteSelectedRecord(RecordId: integer);
    procedure EditSelectedRecord(RecordId: integer);
    procedure LoadData; override;
    function CreateGridInFormCreate: Boolean; override;

    function InitSortCol: Integer; override;
    function InitSortDirection: TSortDirection; override;

    procedure SetPostCodeValidation(bValid: boolean);
    procedure SetDateAddedValidation(bValid: boolean);
    procedure InitialiseFieldMessages;
    procedure SetCountryCode;
    procedure SetCountry;
    procedure SetCountryFromCountryCode(ACountryCode: string);
  public
    { Public declarations }
    procedure ViewData(const ARecordId: string);
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;
    procedure PrepareForm; override;
//    procedure LoadData; override;
    function GetEditFormClass: TFormClass; override;
    property PostCodeValid: boolean read FPostCodeValid write SetPostCodeValidation;
//    property DateAddedValid: boolean read FDateAddedValid write SetDateAddedValidation;
  protected procedure LoadDFMValues; override; end;

var
  ManualEntryListForm: TManualEntryListForm;

implementation

{$R *.dfm}

uses
  SMX.Web.Layout.Utils,
  MainDataModule,
  SMX.Web.Service.Consts,
  SMX.CRM.Utils,
  SMX.Web.Document.Utils,
  GA.Web.Utils,
  System.DateUtils,
{$IFDEF PAS2JS}
  Math;
{$ELSE}
  System.Math;
{$ENDIF}

procedure TManualEntryListForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
begin
end;

function TManualEntryListForm.GetEditFormClass: TFormClass;
begin
end;

procedure TManualEntryListForm.ViewData(const ARecordId: string);
begin
  FBatchId := 0;
  LoadData;
  RefreshTimer.Enabled := false;
  //KSS RefreshData;
end;

procedure TManualEntryListForm.WebFormDestroy(Sender: TObject);
begin
  inherited;
  //
end;

procedure TManualEntryListForm.AddButtonClick(Sender: TObject);
begin
  inherited;
  SaveNewDonation;
end;

procedure TManualEntryListForm.AmountEditKeyPress(Sender: TObject; var Key:
    Char);
begin
  if (not (Key in ['0'..'9','.'])) or ((Key = '.') and (Pos('.', AmountEdit.text) > 0)) then
  begin
    TDocUtils.setControlValidity('AmountEdit', vsInvalid);
    Key := #0;
  end
  else
  begin
    TDocUtils.setControlValidity('AmountEdit', vsValid);
  end;
end;

procedure TManualEntryListForm.DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer; AField: TField;
  AValue: string; AElement: TJSHTMLElementRecord);
var
  RecordId: integer;
  Span: THTMLSpan;

  procedure EditClick(Sender: TObject);
  begin
    EditSelectedRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

  procedure DeleteClick(Sender: TObject);
  begin
    DeleteSelectedRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;


begin
  if ARow = 0 then
    Exit;

  if DataTable.Columns[ACol].Title = 'Donor' then
  begin
    DataTable.Cells[ACol, ARow] := MainDataset.FieldByName('Title').AsString + ' ' +
      MainDataset.FieldByName('FirstName').AsString + ' ' + MainDataset.FieldByName('LastName').AsString;
  end;

  if DataTable.Columns[ACol].Title = 'Address' then
  begin
    DataTable.Cells[ACol, ARow] := MainDataset.FieldByName('Add1').AsString + ' ' +
      MainDataset.FieldByName('City').AsString;
  end;


  if DataTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := MainDataSet.FieldByName('Id').AsInteger;

    Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-edit', 'Edit');
    TLayoutUtils.SetActionRecordId(Span, RecordId);
    Span.OnClick := @EditClick;

    Span := TLayoutUtils.RowActionSpan(AElement.Element, 'fad fa-trash', 'Delete');
    TLayoutUtils.SetActionRecordId(Span, RecordId);
    Span.OnClick := @DeleteClick;
  end;

end;

procedure TManualEntryListForm.DeleteSelectedRecord(RecordId: integer);
begin
  if MainDataSet.Locate('Id', RecordId, []) then
  begin
    try
      MainDataSet.Delete;
    finally

    end;
  end;
end;

procedure TManualEntryListForm.EditSelectedRecord(RecordId: integer);
begin
  if MainDataSet.Locate('Id', RecordId, []) then
  begin
    MainDataSet.Edit;
    //Must be valid so we can show the save button
    AddButton.Caption := 'Update';
    FPostCodeValid := true;
    FDateAddedValid := true;
    AddButton.Enabled := true;
    SetCountry;
  end;
end;

procedure TManualEntryListForm.MainDatasetAfterOpen(Dataset: TDataSet);
begin
  // Need to set dataset into Insert mode when form opens
  // NextRecordTimer.Enabled := true;
end;

procedure TManualEntryListForm.PrepareForm;
begin
  FIdField := 'Id';
  // Set BatchId to zero so no result set is returned. New BatchId will be
  // created on saving of the first donation
  FBatchId := 0;
  InitialiseFieldMessages;
end;

procedure TManualEntryListForm.MainDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
begin
  inherited;
  RefreshTimer.Enabled := true;
end;

procedure TManualEntryListForm.RefreshTimerTimer(Sender: TObject);
begin
  RefreshTimer.Enabled := false;
  RefreshData;
end;

procedure TManualEntryListForm.RefreshData; {$IFDEF PAS2JS}async;{$ENDIF}
var
  FilterStr: string;

begin
  FilterStr := 'ImportBatchId eq ' + FBatchId.ToString;
  FGridPlugin.SetPreparedFilter(FilterStr);

  SetRequiredPostCode(True);
  AddButton.Caption := 'Add';
  FPostCodeValid := false;
  FDateAddedValid := false;
  AddButton.Enabled := false;
//KSS  CheckValidation;
  InitialiseFieldMessages;
  RefreshBatchData;

  NextRecordTimer.Enabled := true;
end;

procedure TManualEntryListForm.GetNewBatchId; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.CreateNewBatch',
    ['Manual', '', MainData.AppUser.InternalId]));
  lResult := lRetval.ResultAsObject;
  FBatchId := JS.toInteger(lResult['value']);

  WaitForBatchIdTimer.Enabled := true;
end;

function TManualEntryListForm.InitSortCol: Integer;
begin
  result := 0;
end;

function TManualEntryListForm.InitSortDirection: TSortDirection;
begin
  result := sdDesc;
end;

procedure TManualEntryListForm.MergeButtonClick(Sender: TObject);
begin
  MergeDataJob;
  FBatchId := 0;
  RefreshData;
  MergeButton.Enabled := false;
end;

procedure TManualEntryListForm.SaveDonationClick(Sender: TObject);
begin
  SaveNewDonation;
  MergeButton.Enabled := true;
end;

procedure TManualEntryListForm.SaveNewDonation;
begin
  if FBatchId = 0 then
  begin
    GetNewBatchId;
  end
  else
  begin
    SaveNewDonationWithBatchId;
  end;
end;

procedure TManualEntryListForm.SaveNewDonationWithBatchId;
var
  lGiftAidValue: currency;
begin
  lGiftAidValue := RoundTo(MainDataset.FieldByName('Amount').AsFloat * 0.25, -2);

  try
    SetCountryCode;
    MainDataset.FieldByName('ImportBatchId').AsInteger := FBatchId;
    MainDataset.FieldByName('SourceType').AsString := 'Manual';
    MainDataset.FieldByName('GiftAid').AsFloat := lGiftAidValue;
    MainDataset.FieldByName('ImportState').AsString := 'Valid';
    MainDataset.Post;
  finally
    MainDataset.ApplyUpdates;
  end;
end;

procedure TManualEntryListForm.SetDateAddedValidation(bValid: boolean);
begin
  FDateAddedValid := bValid;
  CheckValidation;
end;

procedure TManualEntryListForm.SetPostCodeValidation(bValid: boolean);
begin
  FPostCodeValid := bValid;
  CheckValidation;
end;

procedure TManualEntryListForm.UnLockControls(const AUnLock: Boolean);
begin
//
end;

procedure TManualEntryListForm.WaitForBatchIdTimerTimer(Sender: TObject);
begin
  if FBatchId <> 0 then
  begin
    SaveNewDonationWithBatchId;
    WaitForBatchIdTimer.Enabled := false;
  end;
end;

procedure TManualEntryListForm.RefreshBatchData; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
  if FBatchId <> 0 then
  begin
    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.GetManualBatchData', [FBatchId]));
    lResult := lRetval.ResultAsObject;

    FBatchTotal := JS.toNumber(lResult['BatchTotal']);

    FNoOfDonations := JS.toInteger(lResult['NoOfDonations']);
    FNoOfErrors := JS.toInteger(lResult['NoOfErrors']);
    FMergeEnabled := FNoOfErrors = 0;
    WaitForBatchDataTimer.Enabled := true;
  end;
end;

procedure TManualEntryListForm.WaitForBatchDataTimerTimer(Sender: TObject);
begin
  MergeButton.Enabled := FMergeEnabled;
  DonationsData.Caption := Format('Donations Total: %0.2f No of Donations: %d', [FBatchTotal, FNoOfDonations]);
  WaitForBatchDataTimer.Enabled := false;
end;

procedure TManualEntryListForm.MergeDataJob; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lJobParams: JS.TJSObject;
  lRetval: TXDataClientResponse;
  JobId: Integer;
begin
  if FBatchId <> 0 then
  begin
    lJobParams := JS.TJSObject.new;
    lJobParams.Properties['ImportId'] := FBatchId;

    lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(IJOBSVC_SCHEDULEJOB,
      ['TImportMergeJob', 'AnyAdminUser', JS.TJSJSON.stringify(lJobParams), 'Undecided', 'Production']));

    JobId := JS.toInteger(lRetval.ResultAsObject['value']);

    // EnableRefreshTimer;

    ShowAToast('Data Merge', Format('The job to merge your import data has been placed. The Job Number is %d', [JobId]),
      'clock.png');
  end;
end;

procedure TManualEntryListForm.LoadData;
begin
  MainDataset.Load;
end;

procedure TManualEntryListForm.CheckValidation;
begin
  if FPostCodeValid and FDateAddedValid and (Add1Edit.Text <> '') and
     (AmountEdit.Text <> '') and (FirstNameEdit.Text <> '') and
     (LastNameEdit.Text <> '') and (CountryList.ItemIndex <> -1) then
  begin
    CheckForDuplicates;
  end
  else
    AddButton.Enabled := false;
end;

procedure TManualEntryListForm.ClearButtonClick(Sender: TObject);
begin
  try
    MainDataSet.ClearFields;
    FIsDuplicate := False;
    InitialiseFieldMessages;
  finally
  end;
end;

procedure TManualEntryListForm.NextRecordTimerTimer(Sender: TObject);
begin
  NextRecordTimer.Enabled := false;
  MainDataSet.Insert;
  SetCountry;
end;

procedure TManualEntryListForm.WebFormShow(Sender: TObject);
begin
  CreateGridPlugin;
  CheckForOpenManualBatches;
  RefreshData;
end;

function TManualEntryListForm.CreateGridInFormCreate: Boolean;
begin
  cbPageSize.ItemIndex := 3;
  result := false;
end;

procedure TManualEntryListForm.DateAddedEditChange(Sender: TObject);
begin
  ValidateDate;
end;

procedure TManualEntryListForm.PostCodeEditChange(Sender: TObject);
var
  lPostCode: string;
begin
  PostCodeValid := False;
  TDocUtils.setControlValidity('PostCodeEdit', vsNone);

  lPostCode := StringReplace(Trim(PostCodeEdit.Text), ' ', '', [rfReplaceAll]);
  if (lPostCode <> '') and (Length(lPostCode) >= 5) then
    ValidatePostCode;

  CheckValidation;
end;

procedure TManualEntryListForm.PostCodeEditExit(Sender: TObject);
begin
  ValidatePostCode;
  CheckValidation;
end;

procedure TManualEntryListForm.ValidatePostCode;
var
  lPostCode: string;
begin
  lPostCode := Trim(PostCodeEdit.Text).ToUpper;
  while Pos('  ', lPostCode) > 0 do
    lPostCode := StringReplace(lPostCode, '  ', ' ', []);

  if lPostCode = '' then
  begin
    PostCodeValid := False;
    TDocUtils.setControlValidity('PostCodeEdit', vsNone);
    Exit;
  end;

  // Allow users to enter UK postcodes without a space (minimum 5 chars),
  // then normalise to canonical format.
  lPostCode := StringReplace(lPostCode, ' ', '', [rfReplaceAll]);
  if Length(lPostCode) >= 5 then
    lPostCode := TCRMUtils.FormatPostCode(lPostCode);

  PostCodeEdit.Text := lPostCode;
  if TCRMUtils.IsPostCode(lPostCode) <> pcFull then
  begin
    TDocUtils.setControlValidity('PostCodeEdit', vsInvalid);
    PostCodeValid := False;
    Exit;
  end;

  TDocUtils.setControlValidity('PostCodeEdit', vsValid);
  PostCodeValid := True;
  MainDataset.FieldByName('PostCode').AsString := lPostCode;
end;


procedure TManualEntryListForm.InitialiseFieldMessages;
begin
  TDocUtils.setControlValidity('AmountEdit', vsNone);
  TDocUtils.setControlValidity('PostCodeEdit', vsNone);
  TDocUtils.setControlValidity('DateAddedEdit', vsNone);
end;

procedure TManualEntryListForm.MainDatasetAfterDelete(DataSet: TDataSet);
begin
  inherited;
  MainDataSet.ApplyUpdates;
end;

procedure TManualEntryListForm.EditExit(Sender: TObject);
begin
  CheckValidation;
end;

procedure TManualEntryListForm.CountryListChange(Sender: TObject);
begin
  SetCountryCode;
end;

procedure TManualEntryListForm.CountryListExit(Sender: TObject);
begin
  SetCountryCode;
end;

procedure TManualEntryListForm.SetCountryCode;
var
  lCountry: string;
  lCountryCode: string;

begin
  lCountry := CountryList.Text;
  lCountryCode := GetCountryCode(lCountry);

  if not (MainDataset.State in dsEditModes) then
    MainDataset.Edit;

  MainDataset.FieldByName('CountryCode').AsString := lCountryCode;


  if lCountryCode <> 'GB' then
  begin
    FPostCodeValid := True;
    SetRequiredPostCode(False);
  end
  else
  begin
    SetRequiredPostCode(True);
  end;

  CheckValidation;
end;


procedure TManualEntryListForm.SetCountry;
var
  lCountryCode: string;
  lCountry: string;
begin
  if MainDataset.FieldByName('CountryCode').AsString <> '' then
  begin
    lCountryCode := MainDataset.FieldByName('CountryCode').AsString;

    if lCountryCode <> '' then
    begin
      SetCountryFromCountryCode(lCountryCode);
      //lCountry := GetCountryByCode(lCountryCode);
      //CountryList.Text := lCountry;
    end;
  end
  else
  begin
    if MainDataSet.State in [dsInsert] then
      SetCountryFromCountryCode('GB')
    else
      SetCountryFromCountryCode('');
  end;
end;


procedure TManualEntryListForm.SetCountryFromCountryCode(ACountryCode: string);
var
//  lCountryCode: string;
  lCountry: string;
begin
  lCountry := GetCountryByCode(ACountryCode);
  CountryList.Text := lCountry;
end;

procedure TManualEntryListForm.CheckForDuplicates; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
  lFirstName: string;
  lLastName: string;
  lAmountStr: string;
  lAmount: double;
  lTransactionDate: TDate;
  lPostCode: string;
  lIsDuplicate: boolean;
begin
  try
    lFirstName := FirstNameEdit.Text;
    lLastName := LastNameEdit.Text;
    lPostCode := PostCodeEdit.Text;
    lAmountStr := AmountEdit.Text;
    lAmount := lAmountStr.ToDouble;
    lTransactionDate := DateAddedEdit.Date;

    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.ManualEntryDuplicates', [lFirstName, lLastName, lPostCode, lTransactionDate, lAmount, FBatchId]));

    FIsDuplicate := JS.toBoolean(lRetval.ResultAsObject['value']);
    EnableSaveButtonTimer.Enabled := true;
//    CheckEnableSaveButton;
  except

  end;
end;

procedure TManualEntryListForm.EnableSaveButtonTimerTimer(Sender: TObject);
var
  lRes: TModalResult;
begin
  EnableSaveButtonTimer.Enabled := False;
  CheckEnableSaveButton;
end;

procedure TManualEntryListForm.CheckEnableSaveButton; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRes: TModalResult;
  lIsDuplicate: boolean;
begin
  if FIsDuplicate then
  begin
    lRes := await(TModalResult, DeleteDonor.ShowDialog('Is this donation a duplicate?', WEBLib.Dialogs.mtConfirmation, [mbYes, mbNo]));

    if lRes = mrYes then
      lIsDuplicate := True
    else
      lIsDuplicate := False;
  end;

  AddButton.Enabled := not lIsDuplicate;
end;


procedure TManualEntryListForm.ValidateDate;
var
  lValidDate: TDate;
  lYear: string;
  lMonth: string;
  lDay: string;
  lDateStr: string;
  lEarliestDate: TDateTime;
begin
  FDateAddedValid := False;
  lDateStr := DateAddedEdit.Text;

  if Length(lDateStr) > 10 then
    DateAddedEdit.Text := Copy(lDateStr, 1, 10);

  if Length(lDateStr) >= 10 then
  begin
    lDay := Copy(lDateStr,9,2);
  end;

  if Length(lDateStr) >= 7 then
  begin
    lMonth := Copy(lDateStr,6,2);
  end;

  if Length(lDateStr) >= 4 then
  begin
    lYear := Copy(lDateStr,1,4);
  end;

  if (lDay <> '') and (lMonth <> '') and (lYear <> '') and (lYear.ToInteger > 2000) then
  begin
    if IsValidDate(lYear.ToInteger, lMonth.ToInteger, lDay.ToInteger) then
    begin
      if DateAddedEdit.Date > Date then
      begin
        ErrorMessageTransactionDate.Caption := 'Date in the future';
        TDocUtils.setControlValidity('DateAddedEdit', vsInvalid);
        FDateAddedValid := false;
      end
      else
      begin
        lEarliestDate := TGAWebUtils.EarliestClaimableDate(Now);

        if lEarliestDate > DateAddedEdit.Date then
        begin
          ErrorMessageTransactionDate.Caption := 'Date can not be before ' + FormatDateTime('DD/MM/YYYY', lEarliestDate);
          TDocUtils.setControlValidity('DateAddedEdit', vsInvalid);
          FDateAddedValid := False;
        end
        else
        begin
          TDocUtils.setControlValidity('DateAddedEdit', vsValid);
          FDateAddedValid := true;
        end;
      end;
    end;
  end;

  if (Length(DateAddedEdit.Text) = 10) then
    CheckValidation;
end;

procedure TManualEntryListForm.CheckForOpenManualBatches; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.CheckForOpenBatch',
    [MainData.AppUser.InternalId]));
  lResult := lRetval.ResultAsObject;
  FBatchId := JS.toInteger(lResult['value']);

  RefreshTimer.Enabled := true;
end;

procedure TManualEntryListForm.SetRequiredPostCode(ARequired: boolean);
begin
  PostCodeEdit.Enabled := ARequired;
end;

procedure TManualEntryListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  DonationsData := TLabel.Create(Self);
  ErrorMessageTransactionDate := TLabel.Create('ErrorMessageTransactionDate');
  TitleEdit := TDBEdit.Create('TitleEdit');
  FirstNameEdit := TDBEdit.Create('FirstNameEdit');
  LastNameEdit := TDBEdit.Create('LastNameEdit');
  Add1Edit := TDBEdit.Create('Add1Edit');
  Add2Edit := TDBEdit.Create('Add2Edit');
  Add3Edit := TDBEdit.Create('Add3Edit');
  DateAddedEdit := TDBDateTimePicker.Create('DateAddedEdit');
  PostCodeEdit := TDBEdit.Create('PostCodeEdit');
  AmountEdit := TDBEdit.Create('AmountEdit');
  SponsoredEdit := TDBCheckBox.Create('SponsoredEdit');
  CityEdit := TDBEdit.Create('CityEdit');
  MergeButton := TButton.Create('MergeButton');
  ClearButton := TButton.Create('ClearSelectButton');
  MessageDialog := TMessageDlg.Create(Self);
  DuplicateDialog := TMessageDlg.Create(Self);
  CountryList := TCountryComboBox.Create('CountryList');
  DeleteDonation := TMessageDlg.Create('deleteDonation');
  DeleteDonor := TMessageDlg.Create(Self);
  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetTitle := TStringField.Create(Self);
  MainDatasetFirstName := TStringField.Create(Self);
  MainDatasetMiddleName := TStringField.Create(Self);
  MainDatasetLastName := TStringField.Create(Self);
  MainDatasetSuffix := TStringField.Create(Self);
  MainDatasetAdd1 := TStringField.Create(Self);
  MainDatasetAdd2 := TStringField.Create(Self);
  MainDatasetAdd3 := TStringField.Create(Self);
  MainDatasetCity := TStringField.Create(Self);
  MainDatasetPostCode := TStringField.Create(Self);
  MainDatasetEmail := TStringField.Create(Self);
  MainDatasetMobile := TStringField.Create(Self);
  MainDatasetTelephone := TStringField.Create(Self);
  MainDatasetMatchHash := TStringField.Create(Self);
  MainDatasetContactByPhone := TBooleanField.Create(Self);
  MainDatasetContactByPost := TBooleanField.Create(Self);
  MainDatasetContactByText := TBooleanField.Create(Self);
  MainDatasetContactByEmail := TBooleanField.Create(Self);
  MainDatasetDOB := TDateField.Create(Self);
  MainDatasetHearingStatus := TStringField.Create(Self);
  MainDatasetEmailStatus := TStringField.Create(Self);
  MainDatasetLatitude := TFloatField.Create(Self);
  MainDatasetLongitude := TFloatField.Create(Self);
  MainDatasetExternalId := TStringField.Create(Self);
  MainDatasetCountryCode := TStringField.Create(Self);
  MainDatasetVisualStatus := TStringField.Create(Self);
  MainDatasetMobilityStatus := TStringField.Create(Self);
  MainDatasetSourceType := TStringField.Create(Self);
  MainDatasetClaimStatus := TStringField.Create(Self);
  MainDatasetCharityTenant := TStringField.Create(Self);
  MainDatasetImportState := TStringField.Create(Self);
  MainDatasetErrorText := TStringField.Create(Self);
  MainDatasetImportBatchId := TIntegerField.Create(Self);
  MainDatasetSponsored := TBooleanField.Create(Self);
  MainDatasetDonationDate := TDateTimeField.Create(Self);
  MainDatasetGiftAid := TFloatField.Create(Self);
  MainDatasetAmount := TFloatField.Create(Self);
  MainDatasetExternalDonationId := TStringField.Create(Self);
  MainDatasetMatchedPerson := TIntegerField.Create(Self);
  MainDatasetExternalDonationId2 := TStringField.Create(Self);
  RefreshTimer := TTimer.Create(Self);
  WaitForBatchIdTimer := TTimer.Create(Self);
  WaitForBatchDataTimer := TTimer.Create(Self);
  NextRecordTimer := TTimer.Create(Self);
  EnableSaveButtonTimer := TTimer.Create(Self);

  MessageLabel.BeforeLoadDFMValues;
  DonationsData.BeforeLoadDFMValues;
  ErrorMessageTransactionDate.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  DataTable.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  SearchButton.BeforeLoadDFMValues;
  ListWaitMessage.BeforeLoadDFMValues;
  TitleEdit.BeforeLoadDFMValues;
  FirstNameEdit.BeforeLoadDFMValues;
  LastNameEdit.BeforeLoadDFMValues;
  Add1Edit.BeforeLoadDFMValues;
  Add2Edit.BeforeLoadDFMValues;
  Add3Edit.BeforeLoadDFMValues;
  DateAddedEdit.BeforeLoadDFMValues;
  PostCodeEdit.BeforeLoadDFMValues;
  AmountEdit.BeforeLoadDFMValues;
  SponsoredEdit.BeforeLoadDFMValues;
  CityEdit.BeforeLoadDFMValues;
  MergeButton.BeforeLoadDFMValues;
  ClearButton.BeforeLoadDFMValues;
  MessageDialog.BeforeLoadDFMValues;
  DuplicateDialog.BeforeLoadDFMValues;
  CountryList.BeforeLoadDFMValues;
  DeleteDonation.BeforeLoadDFMValues;
  DeleteDonor.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetTitle.BeforeLoadDFMValues;
  MainDatasetFirstName.BeforeLoadDFMValues;
  MainDatasetMiddleName.BeforeLoadDFMValues;
  MainDatasetLastName.BeforeLoadDFMValues;
  MainDatasetSuffix.BeforeLoadDFMValues;
  MainDatasetAdd1.BeforeLoadDFMValues;
  MainDatasetAdd2.BeforeLoadDFMValues;
  MainDatasetAdd3.BeforeLoadDFMValues;
  MainDatasetCity.BeforeLoadDFMValues;
  MainDatasetPostCode.BeforeLoadDFMValues;
  MainDatasetEmail.BeforeLoadDFMValues;
  MainDatasetMobile.BeforeLoadDFMValues;
  MainDatasetTelephone.BeforeLoadDFMValues;
  MainDatasetMatchHash.BeforeLoadDFMValues;
  MainDatasetContactByPhone.BeforeLoadDFMValues;
  MainDatasetContactByPost.BeforeLoadDFMValues;
  MainDatasetContactByText.BeforeLoadDFMValues;
  MainDatasetContactByEmail.BeforeLoadDFMValues;
  MainDatasetDOB.BeforeLoadDFMValues;
  MainDatasetHearingStatus.BeforeLoadDFMValues;
  MainDatasetEmailStatus.BeforeLoadDFMValues;
  MainDatasetLatitude.BeforeLoadDFMValues;
  MainDatasetLongitude.BeforeLoadDFMValues;
  MainDatasetExternalId.BeforeLoadDFMValues;
  MainDatasetCountryCode.BeforeLoadDFMValues;
  MainDatasetVisualStatus.BeforeLoadDFMValues;
  MainDatasetMobilityStatus.BeforeLoadDFMValues;
  MainDatasetSourceType.BeforeLoadDFMValues;
  MainDatasetClaimStatus.BeforeLoadDFMValues;
  MainDatasetCharityTenant.BeforeLoadDFMValues;
  MainDatasetImportState.BeforeLoadDFMValues;
  MainDatasetErrorText.BeforeLoadDFMValues;
  MainDatasetImportBatchId.BeforeLoadDFMValues;
  MainDatasetSponsored.BeforeLoadDFMValues;
  MainDatasetDonationDate.BeforeLoadDFMValues;
  MainDatasetGiftAid.BeforeLoadDFMValues;
  MainDatasetAmount.BeforeLoadDFMValues;
  MainDatasetExternalDonationId.BeforeLoadDFMValues;
  MainDatasetMatchedPerson.BeforeLoadDFMValues;
  MainDatasetExternalDonationId2.BeforeLoadDFMValues;
  MainDataSource.BeforeLoadDFMValues;
  WebElementActionList1.BeforeLoadDFMValues;
  ListCloseTimer.BeforeLoadDFMValues;
  RefreshTimer.BeforeLoadDFMValues;
  WaitForBatchIdTimer.BeforeLoadDFMValues;
  WaitForBatchDataTimer.BeforeLoadDFMValues;
  NextRecordTimer.BeforeLoadDFMValues;
  EnableSaveButtonTimer.BeforeLoadDFMValues;
  try
    Width := 577;
    Height := 637;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    MessageLabel.Left := 430;
    MessageLabel.Top := 344;
    DonationsData.SetParentComponent(Self);
    DonationsData.Name := 'DonationsData';
    DonationsData.Left := 24;
    DonationsData.Top := 584;
    DonationsData.Width := 119;
    DonationsData.Height := 25;
    DonationsData.Caption := 'DonationsData';
    DonationsData.ElementPosition := epIgnore;
    DonationsData.HeightStyle := ssAuto;
    DonationsData.HeightPercent := 100.000000000000000000;
    DonationsData.Visible := False;
    DonationsData.WidthStyle := ssAuto;
    DonationsData.WidthPercent := 100.000000000000000000;
    ErrorMessageTransactionDate.SetParentComponent(Self);
    ErrorMessageTransactionDate.Name := 'ErrorMessageTransactionDate';
    ErrorMessageTransactionDate.Left := 400;
    ErrorMessageTransactionDate.Top := 160;
    ErrorMessageTransactionDate.Width := 233;
    ErrorMessageTransactionDate.Height := 25;
    ErrorMessageTransactionDate.Caption := 'ErrorMessageTransactionDate';
    ErrorMessageTransactionDate.ElementPosition := epIgnore;
    ErrorMessageTransactionDate.HeightStyle := ssAuto;
    ErrorMessageTransactionDate.HeightPercent := 100.000000000000000000;
    ErrorMessageTransactionDate.WidthStyle := ssAuto;
    ErrorMessageTransactionDate.WidthPercent := 100.000000000000000000;
    cbPageSize.Left := 430;
    cbPageSize.Top := 315;
    cbPageSize.Visible := False;
    edSearch.Left := 240;
    edSearch.Top := 338;
    edSearch.Visible := False;
    lcPaginator.Visible := False;
    DataTable.Left := 24;
    DataTable.Top := 408;
    DataTable.Height := 158;
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'DonationDate';
      Title := 'Date';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Donor';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Address';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Amount';
      Title := 'Amount';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ImportState';
      Title := 'ClaimStatus';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    AddButton.Left := 433;
    AddButton.Top := 580;
    SetEvent(AddButton, Self, 'OnClick', 'SaveDonationClick');
    SearchButton.Left := 367;
    SearchButton.Top := 334;
    SearchButton.Visible := False;
    ListWaitMessage.Left := 360;
    ListWaitMessage.Top := 262;
    TitleEdit.SetParentComponent(Self);
    TitleEdit.Name := 'TitleEdit';
    TitleEdit.Left := 16;
    TitleEdit.Top := 8;
    TitleEdit.Width := 121;
    TitleEdit.Height := 22;
    TitleEdit.AutoCompletion := acNone;
    TitleEdit.AutoSelect := False;
    TitleEdit.ChildOrder := 4;
    TitleEdit.ElementClassName := 'form-control';
    TitleEdit.ElementFont := efCSS;
    TitleEdit.ElementPosition := epIgnore;
    TitleEdit.HeightStyle := ssAuto;
    TitleEdit.HeightPercent := 100.000000000000000000;
    TitleEdit.TabOrder := 1;
    TitleEdit.Text := 'TitleEdit';
    TitleEdit.WidthStyle := ssAuto;
    TitleEdit.WidthPercent := 100.000000000000000000;
    SetEvent(TitleEdit, Self, 'OnExit', 'EditExit');
    TitleEdit.DataField := 'Title';
    TitleEdit.DataSource := MainDataSource;
    FirstNameEdit.SetParentComponent(Self);
    FirstNameEdit.Name := 'FirstNameEdit';
    FirstNameEdit.Left := 16;
    FirstNameEdit.Top := 36;
    FirstNameEdit.Width := 121;
    FirstNameEdit.Height := 22;
    FirstNameEdit.AutoCompletion := acNone;
    FirstNameEdit.AutoSelect := False;
    FirstNameEdit.ChildOrder := 5;
    FirstNameEdit.ElementClassName := 'form-control';
    FirstNameEdit.ElementFont := efCSS;
    FirstNameEdit.ElementPosition := epIgnore;
    FirstNameEdit.HeightStyle := ssAuto;
    FirstNameEdit.HeightPercent := 100.000000000000000000;
    FirstNameEdit.TabOrder := 2;
    FirstNameEdit.Text := 'FirstNameEdit';
    FirstNameEdit.WidthStyle := ssAuto;
    FirstNameEdit.WidthPercent := 100.000000000000000000;
    SetEvent(FirstNameEdit, Self, 'OnExit', 'EditExit');
    FirstNameEdit.DataField := 'FirstName';
    FirstNameEdit.DataSource := MainDataSource;
    LastNameEdit.SetParentComponent(Self);
    LastNameEdit.Name := 'LastNameEdit';
    LastNameEdit.Left := 16;
    LastNameEdit.Top := 92;
    LastNameEdit.Width := 121;
    LastNameEdit.Height := 22;
    LastNameEdit.AutoCompletion := acNone;
    LastNameEdit.AutoSelect := False;
    LastNameEdit.ChildOrder := 7;
    LastNameEdit.ElementClassName := 'form-control';
    LastNameEdit.ElementFont := efCSS;
    LastNameEdit.ElementPosition := epIgnore;
    LastNameEdit.HeightStyle := ssAuto;
    LastNameEdit.HeightPercent := 100.000000000000000000;
    LastNameEdit.TabOrder := 4;
    LastNameEdit.Text := 'LastNameEdit';
    LastNameEdit.WidthStyle := ssAuto;
    LastNameEdit.WidthPercent := 100.000000000000000000;
    SetEvent(LastNameEdit, Self, 'OnExit', 'EditExit');
    LastNameEdit.DataField := 'LastName';
    LastNameEdit.DataSource := MainDataSource;
    Add1Edit.SetParentComponent(Self);
    Add1Edit.Name := 'Add1Edit';
    Add1Edit.Left := 16;
    Add1Edit.Top := 120;
    Add1Edit.Width := 121;
    Add1Edit.Height := 22;
    Add1Edit.AutoCompletion := acNone;
    Add1Edit.AutoSelect := False;
    Add1Edit.ChildOrder := 8;
    Add1Edit.ElementClassName := 'form-control';
    Add1Edit.ElementFont := efCSS;
    Add1Edit.ElementPosition := epIgnore;
    Add1Edit.HeightStyle := ssAuto;
    Add1Edit.HeightPercent := 100.000000000000000000;
    Add1Edit.TabOrder := 5;
    Add1Edit.Text := 'Add1Edit';
    Add1Edit.WidthStyle := ssAuto;
    Add1Edit.WidthPercent := 100.000000000000000000;
    SetEvent(Add1Edit, Self, 'OnExit', 'EditExit');
    Add1Edit.DataField := 'Add1';
    Add1Edit.DataSource := MainDataSource;
    Add2Edit.SetParentComponent(Self);
    Add2Edit.Name := 'Add2Edit';
    Add2Edit.Left := 16;
    Add2Edit.Top := 148;
    Add2Edit.Width := 121;
    Add2Edit.Height := 22;
    Add2Edit.AutoCompletion := acNone;
    Add2Edit.AutoSelect := False;
    Add2Edit.ChildOrder := 8;
    Add2Edit.ElementClassName := 'form-control';
    Add2Edit.ElementFont := efCSS;
    Add2Edit.ElementPosition := epIgnore;
    Add2Edit.HeightStyle := ssAuto;
    Add2Edit.HeightPercent := 100.000000000000000000;
    Add2Edit.TabOrder := 6;
    Add2Edit.Text := 'Add2Edit';
    Add2Edit.WidthStyle := ssAuto;
    Add2Edit.WidthPercent := 100.000000000000000000;
    Add2Edit.DataField := 'Add2';
    Add2Edit.DataSource := MainDataSource;
    Add3Edit.SetParentComponent(Self);
    Add3Edit.Name := 'Add3Edit';
    Add3Edit.Left := 16;
    Add3Edit.Top := 176;
    Add3Edit.Width := 121;
    Add3Edit.Height := 22;
    Add3Edit.AutoCompletion := acNone;
    Add3Edit.AutoSelect := False;
    Add3Edit.ChildOrder := 8;
    Add3Edit.ElementClassName := 'form-control';
    Add3Edit.ElementFont := efCSS;
    Add3Edit.ElementPosition := epIgnore;
    Add3Edit.HeightStyle := ssAuto;
    Add3Edit.HeightPercent := 100.000000000000000000;
    Add3Edit.TabOrder := 7;
    Add3Edit.Text := 'Add3Edit';
    Add3Edit.WidthStyle := ssAuto;
    Add3Edit.WidthPercent := 100.000000000000000000;
    Add3Edit.DataField := 'Add3';
    Add3Edit.DataSource := MainDataSource;
    DateAddedEdit.SetParentComponent(Self);
    DateAddedEdit.Name := 'DateAddedEdit';
    DateAddedEdit.Left := 16;
    DateAddedEdit.Top := 264;
    DateAddedEdit.Width := 170;
    DateAddedEdit.Height := 22;
    DateAddedEdit.ElementClassName := 'form-control';
    DateAddedEdit.HeightStyle := ssAuto;
    DateAddedEdit.WidthStyle := ssAuto;
    DateAddedEdit.BorderStyle := bsSingle;
    DateAddedEdit.ChildOrder := 12;
    DateAddedEdit.Color := clWhite;
    DateAddedEdit.Date := 45184.273425937500000000;
    DateAddedEdit.ElementFont := efCSS;
    DateAddedEdit.ElementPosition := epIgnore;
    DateAddedEdit.Role := '';
    DateAddedEdit.TabOrder := 12;
    DateAddedEdit.Text := '';
    SetEvent(DateAddedEdit, Self, 'OnChange', 'DateAddedEditChange');
    DateAddedEdit.DataField := 'DonationDate';
    DateAddedEdit.DataSource := MainDataSource;
    PostCodeEdit.SetParentComponent(Self);
    PostCodeEdit.Name := 'PostCodeEdit';
    PostCodeEdit.Left := 16;
    PostCodeEdit.Top := 236;
    PostCodeEdit.Width := 121;
    PostCodeEdit.Height := 22;
    PostCodeEdit.AutoCompletion := acNone;
    PostCodeEdit.AutoSelect := False;
    PostCodeEdit.CharCase := wecUpperCase;
    PostCodeEdit.ChildOrder := 13;
    PostCodeEdit.ElementClassName := 'form-control';
    PostCodeEdit.ElementFont := efCSS;
    PostCodeEdit.ElementPosition := epIgnore;
    PostCodeEdit.HeightStyle := ssAuto;
    PostCodeEdit.HeightPercent := 100.000000000000000000;
    PostCodeEdit.TabOrder := 9;
    PostCodeEdit.Text := 'PostCodeEdit';
    PostCodeEdit.WidthStyle := ssAuto;
    PostCodeEdit.WidthPercent := 100.000000000000000000;
    SetEvent(PostCodeEdit, Self, 'OnChange', 'PostCodeEditChange');
    SetEvent(PostCodeEdit, Self, 'OnExit', 'PostCodeEditExit');
    PostCodeEdit.DataField := 'PostCode';
    PostCodeEdit.DataSource := MainDataSource;
    AmountEdit.SetParentComponent(Self);
    AmountEdit.Name := 'AmountEdit';
    AmountEdit.Left := 16;
    AmountEdit.Top := 292;
    AmountEdit.Width := 121;
    AmountEdit.Height := 22;
    AmountEdit.AutoCompletion := acNone;
    AmountEdit.AutoSelect := False;
    AmountEdit.ChildOrder := 14;
    AmountEdit.ElementClassName := 'form-control';
    AmountEdit.ElementFont := efCSS;
    AmountEdit.ElementPosition := epIgnore;
    AmountEdit.HeightStyle := ssAuto;
    AmountEdit.HeightPercent := 100.000000000000000000;
    AmountEdit.TabOrder := 11;
    AmountEdit.Text := 'AmountEdit';
    AmountEdit.WidthStyle := ssAuto;
    AmountEdit.WidthPercent := 100.000000000000000000;
    SetEvent(AmountEdit, Self, 'OnExit', 'EditExit');
    SetEvent(AmountEdit, Self, 'OnKeyPress', 'AmountEditKeyPress');
    AmountEdit.DataField := 'Amount';
    AmountEdit.DataSource := MainDataSource;
    SponsoredEdit.SetParentComponent(Self);
    SponsoredEdit.Name := 'SponsoredEdit';
    SponsoredEdit.Left := 16;
    SponsoredEdit.Top := 348;
    SponsoredEdit.Width := 113;
    SponsoredEdit.Height := 22;
    SponsoredEdit.Caption := 'SponsoredEdit';
    SponsoredEdit.ChildOrder := 15;
    SponsoredEdit.ElementClassName := 'custom-control custom-checkbox';
    SponsoredEdit.ElementButtonClassName := 'custom-control-input';
    SponsoredEdit.ElementLabelClassName := 'custom-control-label';
    SponsoredEdit.ElementFont := efCSS;
    SponsoredEdit.ElementPosition := epIgnore;
    SponsoredEdit.HeightStyle := ssAuto;
    SponsoredEdit.HeightPercent := 100.000000000000000000;
    SponsoredEdit.TabOrder := 14;
    SponsoredEdit.WidthStyle := ssAuto;
    SponsoredEdit.WidthPercent := 100.000000000000000000;
    SponsoredEdit.DataField := 'Sponsored';
    SponsoredEdit.DataSource := MainDataSource;
    CityEdit.SetParentComponent(Self);
    CityEdit.Name := 'CityEdit';
    CityEdit.Left := 16;
    CityEdit.Top := 208;
    CityEdit.Width := 121;
    CityEdit.Height := 22;
    CityEdit.AutoCompletion := acNone;
    CityEdit.AutoSelect := False;
    CityEdit.ChildOrder := 16;
    CityEdit.ElementClassName := 'form-control';
    CityEdit.ElementFont := efCSS;
    CityEdit.ElementPosition := epIgnore;
    CityEdit.HeightStyle := ssAuto;
    CityEdit.HeightPercent := 100.000000000000000000;
    CityEdit.TabOrder := 8;
    CityEdit.Text := 'CityEdit';
    CityEdit.WidthStyle := ssAuto;
    CityEdit.WidthPercent := 100.000000000000000000;
    SetEvent(CityEdit, Self, 'OnExit', 'EditExit');
    CityEdit.DataField := 'City';
    CityEdit.DataSource := MainDataSource;
    MergeButton.SetParentComponent(Self);
    MergeButton.Name := 'MergeButton';
    MergeButton.Left := 331;
    MergeButton.Top := 581;
    MergeButton.Width := 96;
    MergeButton.Height := 24;
    MergeButton.Caption := 'Save';
    MergeButton.ChildOrder := 23;
    MergeButton.Enabled := False;
    MergeButton.HeightPercent := 100.000000000000000000;
    MergeButton.WidthPercent := 100.000000000000000000;
    SetEvent(MergeButton, Self, 'OnClick', 'MergeButtonClick');
    ClearButton.SetParentComponent(Self);
    ClearButton.Name := 'ClearButton';
    ClearButton.Left := 229;
    ClearButton.Top := 580;
    ClearButton.Width := 96;
    ClearButton.Height := 25;
    ClearButton.Caption := 'Clear';
    ClearButton.ChildOrder := 24;
    ClearButton.HeightPercent := 100.000000000000000000;
    ClearButton.WidthPercent := 100.000000000000000000;
    SetEvent(ClearButton, Self, 'OnClick', 'ClearButtonClick');
    MessageDialog.SetParentComponent(Self);
    MessageDialog.Name := 'MessageDialog';
    MessageDialog.Left := 517;
    MessageDialog.Top := 191;
    MessageDialog.Width := 24;
    MessageDialog.Height := 24;
    MessageDialog.Buttons := [];
    MessageDialog.Opacity := 0.200000000000000000;
    DuplicateDialog.SetParentComponent(Self);
    DuplicateDialog.Name := 'DuplicateDialog';
    DuplicateDialog.Left := 488;
    DuplicateDialog.Top := 80;
    DuplicateDialog.Width := 24;
    DuplicateDialog.Height := 24;
    DuplicateDialog.HeightStyle := ssAuto;
    DuplicateDialog.WidthStyle := ssAuto;
    DuplicateDialog.Buttons := [];
    DuplicateDialog.Opacity := 0.200000000000000000;
    CountryList.SetParentComponent(Self);
    CountryList.Name := 'CountryList';
    CountryList.Left := 16;
    CountryList.Top := 320;
    CountryList.Width := 170;
    CountryList.Height := 33;
    CountryList.ElementClassName := 'form-select';
    CountryList.ElementPosition := epIgnore;
    CountryList.HeightPercent := 100.000000000000000000;
    CountryList.TabStop := False;
    CountryList.WidthStyle := ssAuto;
    CountryList.WidthPercent := 100.000000000000000000;
    SetEvent(CountryList, Self, 'OnChange', 'CountryListChange');
    SetEvent(CountryList, Self, 'OnExit', 'CountryListExit');
    CountryList.ItemIndex := -1;
    DeleteDonation.SetParentComponent(Self);
    DeleteDonation.Name := 'DeleteDonation';
    DeleteDonation.Left := 553;
    DeleteDonation.Top := 136;
    DeleteDonation.Width := 24;
    DeleteDonation.Height := 24;
    DeleteDonation.HeightStyle := ssAuto;
    DeleteDonation.WidthStyle := ssAuto;
    DeleteDonation.Buttons := [mbYes,mbNo];
    DeleteDonation.DialogType := mtConfirmation;
    DeleteDonation.Opacity := 0.200000000000000000;
    DeleteDonation.ElementButtonClassName := 'btn';
    DeleteDonation.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    DeleteDonation.ElementTitleClassName := 'text-body';
    DeleteDonation.ElementContentClassName := 'text-body';
    DeleteDonor.SetParentComponent(Self);
    DeleteDonor.Name := 'DeleteDonor';
    DeleteDonor.Left := 537;
    DeleteDonor.Top := 314;
    DeleteDonor.Width := 24;
    DeleteDonor.Height := 24;
    DeleteDonor.Buttons := [];
    DeleteDonor.Opacity := 0.200000000000000000;
    DeleteDonor.Visible := False;
    MainDataset.AfterApplyUpdates := MainDatasetAfterApplyUpdates;
    MainDataset.AfterDelete := MainDatasetAfterDelete;
    MainDataset.EntitySetName := 'ImportDonation';
    MainDataset.Left := 224;
    MainDataset.Top := 88;
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetTitle.SetParentComponent(MainDataset);
    MainDatasetTitle.Name := 'MainDatasetTitle';
    MainDatasetTitle.FieldName := 'Title';
    MainDatasetTitle.Size := 25;
    MainDatasetFirstName.SetParentComponent(MainDataset);
    MainDatasetFirstName.Name := 'MainDatasetFirstName';
    MainDatasetFirstName.FieldName := 'FirstName';
    MainDatasetFirstName.Size := 50;
    MainDatasetMiddleName.SetParentComponent(MainDataset);
    MainDatasetMiddleName.Name := 'MainDatasetMiddleName';
    MainDatasetMiddleName.FieldName := 'MiddleName';
    MainDatasetMiddleName.Size := 50;
    MainDatasetLastName.SetParentComponent(MainDataset);
    MainDatasetLastName.Name := 'MainDatasetLastName';
    MainDatasetLastName.FieldName := 'LastName';
    MainDatasetLastName.Size := 50;
    MainDatasetSuffix.SetParentComponent(MainDataset);
    MainDatasetSuffix.Name := 'MainDatasetSuffix';
    MainDatasetSuffix.FieldName := 'Suffix';
    MainDatasetSuffix.Size := 50;
    MainDatasetAdd1.SetParentComponent(MainDataset);
    MainDatasetAdd1.Name := 'MainDatasetAdd1';
    MainDatasetAdd1.FieldName := 'Add1';
    MainDatasetAdd1.Size := 75;
    MainDatasetAdd2.SetParentComponent(MainDataset);
    MainDatasetAdd2.Name := 'MainDatasetAdd2';
    MainDatasetAdd2.FieldName := 'Add2';
    MainDatasetAdd2.Size := 75;
    MainDatasetAdd3.SetParentComponent(MainDataset);
    MainDatasetAdd3.Name := 'MainDatasetAdd3';
    MainDatasetAdd3.FieldName := 'Add3';
    MainDatasetAdd3.Size := 75;
    MainDatasetCity.SetParentComponent(MainDataset);
    MainDatasetCity.Name := 'MainDatasetCity';
    MainDatasetCity.FieldName := 'City';
    MainDatasetCity.Size := 75;
    MainDatasetPostCode.SetParentComponent(MainDataset);
    MainDatasetPostCode.Name := 'MainDatasetPostCode';
    MainDatasetPostCode.FieldName := 'PostCode';
    MainDatasetPostCode.Size := 15;
    MainDatasetEmail.SetParentComponent(MainDataset);
    MainDatasetEmail.Name := 'MainDatasetEmail';
    MainDatasetEmail.FieldName := 'Email';
    MainDatasetEmail.Size := 75;
    MainDatasetMobile.SetParentComponent(MainDataset);
    MainDatasetMobile.Name := 'MainDatasetMobile';
    MainDatasetMobile.FieldName := 'Mobile';
    MainDatasetMobile.Size := 25;
    MainDatasetTelephone.SetParentComponent(MainDataset);
    MainDatasetTelephone.Name := 'MainDatasetTelephone';
    MainDatasetTelephone.FieldName := 'Telephone';
    MainDatasetTelephone.Size := 25;
    MainDatasetMatchHash.SetParentComponent(MainDataset);
    MainDatasetMatchHash.Name := 'MainDatasetMatchHash';
    MainDatasetMatchHash.FieldName := 'MatchHash';
    MainDatasetMatchHash.Size := 64;
    MainDatasetContactByPhone.SetParentComponent(MainDataset);
    MainDatasetContactByPhone.Name := 'MainDatasetContactByPhone';
    MainDatasetContactByPhone.FieldName := 'ContactByPhone';
    MainDatasetContactByPost.SetParentComponent(MainDataset);
    MainDatasetContactByPost.Name := 'MainDatasetContactByPost';
    MainDatasetContactByPost.FieldName := 'ContactByPost';
    MainDatasetContactByText.SetParentComponent(MainDataset);
    MainDatasetContactByText.Name := 'MainDatasetContactByText';
    MainDatasetContactByText.FieldName := 'ContactByText';
    MainDatasetContactByEmail.SetParentComponent(MainDataset);
    MainDatasetContactByEmail.Name := 'MainDatasetContactByEmail';
    MainDatasetContactByEmail.FieldName := 'ContactByEmail';
    MainDatasetDOB.SetParentComponent(MainDataset);
    MainDatasetDOB.Name := 'MainDatasetDOB';
    MainDatasetDOB.FieldName := 'DOB';
    MainDatasetHearingStatus.SetParentComponent(MainDataset);
    MainDatasetHearingStatus.Name := 'MainDatasetHearingStatus';
    MainDatasetHearingStatus.FieldName := 'HearingStatus';
    MainDatasetHearingStatus.Size := 8;
    MainDatasetEmailStatus.SetParentComponent(MainDataset);
    MainDatasetEmailStatus.Name := 'MainDatasetEmailStatus';
    MainDatasetEmailStatus.FieldName := 'EmailStatus';
    MainDatasetEmailStatus.Size := 10;
    MainDatasetLatitude.SetParentComponent(MainDataset);
    MainDatasetLatitude.Name := 'MainDatasetLatitude';
    MainDatasetLatitude.FieldName := 'Latitude';
    MainDatasetLongitude.SetParentComponent(MainDataset);
    MainDatasetLongitude.Name := 'MainDatasetLongitude';
    MainDatasetLongitude.FieldName := 'Longitude';
    MainDatasetExternalId.SetParentComponent(MainDataset);
    MainDatasetExternalId.Name := 'MainDatasetExternalId';
    MainDatasetExternalId.FieldName := 'ExternalId';
    MainDatasetExternalId.Size := 64;
    MainDatasetCountryCode.SetParentComponent(MainDataset);
    MainDatasetCountryCode.Name := 'MainDatasetCountryCode';
    MainDatasetCountryCode.FieldName := 'CountryCode';
    MainDatasetCountryCode.Size := 3;
    MainDatasetVisualStatus.SetParentComponent(MainDataset);
    MainDatasetVisualStatus.Name := 'MainDatasetVisualStatus';
    MainDatasetVisualStatus.FieldName := 'VisualStatus';
    MainDatasetVisualStatus.Size := 8;
    MainDatasetMobilityStatus.SetParentComponent(MainDataset);
    MainDatasetMobilityStatus.Name := 'MainDatasetMobilityStatus';
    MainDatasetMobilityStatus.FieldName := 'MobilityStatus';
    MainDatasetMobilityStatus.Size := 8;
    MainDatasetSourceType.SetParentComponent(MainDataset);
    MainDatasetSourceType.Name := 'MainDatasetSourceType';
    MainDatasetSourceType.FieldName := 'SourceType';
    MainDatasetSourceType.Size := 9;
    MainDatasetClaimStatus.SetParentComponent(MainDataset);
    MainDatasetClaimStatus.Name := 'MainDatasetClaimStatus';
    MainDatasetClaimStatus.FieldName := 'ClaimStatus';
    MainDatasetClaimStatus.Size := 19;
    MainDatasetCharityTenant.SetParentComponent(MainDataset);
    MainDatasetCharityTenant.Name := 'MainDatasetCharityTenant';
    MainDatasetCharityTenant.FieldName := 'CharityTenant';
    MainDatasetImportState.SetParentComponent(MainDataset);
    MainDatasetImportState.Name := 'MainDatasetImportState';
    MainDatasetImportState.FieldName := 'ImportState';
    MainDatasetImportState.Size := 5;
    MainDatasetErrorText.SetParentComponent(MainDataset);
    MainDatasetErrorText.Name := 'MainDatasetErrorText';
    MainDatasetErrorText.FieldName := 'ErrorText';
    MainDatasetErrorText.Size := 1000;
    MainDatasetImportBatchId.SetParentComponent(MainDataset);
    MainDatasetImportBatchId.Name := 'MainDatasetImportBatchId';
    MainDatasetImportBatchId.FieldName := 'ImportBatchId';
    MainDatasetSponsored.SetParentComponent(MainDataset);
    MainDatasetSponsored.Name := 'MainDatasetSponsored';
    MainDatasetSponsored.FieldName := 'Sponsored';
    MainDatasetDonationDate.SetParentComponent(MainDataset);
    MainDatasetDonationDate.Name := 'MainDatasetDonationDate';
    MainDatasetDonationDate.FieldName := 'DonationDate';
    MainDatasetGiftAid.SetParentComponent(MainDataset);
    MainDatasetGiftAid.Name := 'MainDatasetGiftAid';
    MainDatasetGiftAid.FieldName := 'GiftAid';
    MainDatasetAmount.SetParentComponent(MainDataset);
    MainDatasetAmount.Name := 'MainDatasetAmount';
    MainDatasetAmount.FieldName := 'Amount';
    MainDatasetExternalDonationId.SetParentComponent(MainDataset);
    MainDatasetExternalDonationId.Name := 'MainDatasetExternalDonationId';
    MainDatasetExternalDonationId.FieldName := 'ExternalDonationId';
    MainDatasetExternalDonationId.Size := 255;
    MainDatasetMatchedPerson.SetParentComponent(MainDataset);
    MainDatasetMatchedPerson.Name := 'MainDatasetMatchedPerson';
    MainDatasetMatchedPerson.FieldName := 'MatchedPerson';
    MainDatasetExternalDonationId2.SetParentComponent(MainDataset);
    MainDatasetExternalDonationId2.Name := 'MainDatasetExternalDonationId2';
    MainDatasetExternalDonationId2.FieldName := 'ExternalDonationId2';
    MainDatasetExternalDonationId2.Size := 64;
    MainDataSource.Left := 312;
    MainDataSource.Top := 88;
    WebElementActionList1.Left := 248;
    WebElementActionList1.Top := 264;
    ListCloseTimer.Interval := 10000;
    ListCloseTimer.Left := 448;
    ListCloseTimer.Top := 256;
    RefreshTimer.SetParentComponent(Self);
    RefreshTimer.Name := 'RefreshTimer';
    RefreshTimer.Enabled := False;
    RefreshTimer.Interval := 500;
    SetEvent(RefreshTimer, Self, 'OnTimer', 'RefreshTimerTimer');
    RefreshTimer.Left := 224;
    RefreshTimer.Top := 16;
    WaitForBatchIdTimer.SetParentComponent(Self);
    WaitForBatchIdTimer.Name := 'WaitForBatchIdTimer';
    WaitForBatchIdTimer.Enabled := False;
    SetEvent(WaitForBatchIdTimer, Self, 'OnTimer', 'WaitForBatchIdTimerTimer');
    WaitForBatchIdTimer.Left := 344;
    WaitForBatchIdTimer.Top := 16;
    WaitForBatchDataTimer.SetParentComponent(Self);
    WaitForBatchDataTimer.Name := 'WaitForBatchDataTimer';
    WaitForBatchDataTimer.Enabled := False;
    SetEvent(WaitForBatchDataTimer, Self, 'OnTimer', 'WaitForBatchDataTimerTimer');
    WaitForBatchDataTimer.Left := 480;
    WaitForBatchDataTimer.Top := 24;
    NextRecordTimer.SetParentComponent(Self);
    NextRecordTimer.Name := 'NextRecordTimer';
    NextRecordTimer.Enabled := False;
    NextRecordTimer.Interval := 500;
    SetEvent(NextRecordTimer, Self, 'OnTimer', 'NextRecordTimerTimer');
    NextRecordTimer.Left := 480;
    NextRecordTimer.Top := 112;
    EnableSaveButtonTimer.SetParentComponent(Self);
    EnableSaveButtonTimer.Name := 'EnableSaveButtonTimer';
    EnableSaveButtonTimer.Enabled := False;
    EnableSaveButtonTimer.Interval := 500;
    SetEvent(EnableSaveButtonTimer, Self, 'OnTimer', 'EnableSaveButtonTimerTimer');
    EnableSaveButtonTimer.Left := 520;
    EnableSaveButtonTimer.Top := 232;
  finally
    MessageLabel.AfterLoadDFMValues;
    DonationsData.AfterLoadDFMValues;
    ErrorMessageTransactionDate.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    DataTable.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    SearchButton.AfterLoadDFMValues;
    ListWaitMessage.AfterLoadDFMValues;
    TitleEdit.AfterLoadDFMValues;
    FirstNameEdit.AfterLoadDFMValues;
    LastNameEdit.AfterLoadDFMValues;
    Add1Edit.AfterLoadDFMValues;
    Add2Edit.AfterLoadDFMValues;
    Add3Edit.AfterLoadDFMValues;
    DateAddedEdit.AfterLoadDFMValues;
    PostCodeEdit.AfterLoadDFMValues;
    AmountEdit.AfterLoadDFMValues;
    SponsoredEdit.AfterLoadDFMValues;
    CityEdit.AfterLoadDFMValues;
    MergeButton.AfterLoadDFMValues;
    ClearButton.AfterLoadDFMValues;
    MessageDialog.AfterLoadDFMValues;
    DuplicateDialog.AfterLoadDFMValues;
    CountryList.AfterLoadDFMValues;
    DeleteDonation.AfterLoadDFMValues;
    DeleteDonor.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetTitle.AfterLoadDFMValues;
    MainDatasetFirstName.AfterLoadDFMValues;
    MainDatasetMiddleName.AfterLoadDFMValues;
    MainDatasetLastName.AfterLoadDFMValues;
    MainDatasetSuffix.AfterLoadDFMValues;
    MainDatasetAdd1.AfterLoadDFMValues;
    MainDatasetAdd2.AfterLoadDFMValues;
    MainDatasetAdd3.AfterLoadDFMValues;
    MainDatasetCity.AfterLoadDFMValues;
    MainDatasetPostCode.AfterLoadDFMValues;
    MainDatasetEmail.AfterLoadDFMValues;
    MainDatasetMobile.AfterLoadDFMValues;
    MainDatasetTelephone.AfterLoadDFMValues;
    MainDatasetMatchHash.AfterLoadDFMValues;
    MainDatasetContactByPhone.AfterLoadDFMValues;
    MainDatasetContactByPost.AfterLoadDFMValues;
    MainDatasetContactByText.AfterLoadDFMValues;
    MainDatasetContactByEmail.AfterLoadDFMValues;
    MainDatasetDOB.AfterLoadDFMValues;
    MainDatasetHearingStatus.AfterLoadDFMValues;
    MainDatasetEmailStatus.AfterLoadDFMValues;
    MainDatasetLatitude.AfterLoadDFMValues;
    MainDatasetLongitude.AfterLoadDFMValues;
    MainDatasetExternalId.AfterLoadDFMValues;
    MainDatasetCountryCode.AfterLoadDFMValues;
    MainDatasetVisualStatus.AfterLoadDFMValues;
    MainDatasetMobilityStatus.AfterLoadDFMValues;
    MainDatasetSourceType.AfterLoadDFMValues;
    MainDatasetClaimStatus.AfterLoadDFMValues;
    MainDatasetCharityTenant.AfterLoadDFMValues;
    MainDatasetImportState.AfterLoadDFMValues;
    MainDatasetErrorText.AfterLoadDFMValues;
    MainDatasetImportBatchId.AfterLoadDFMValues;
    MainDatasetSponsored.AfterLoadDFMValues;
    MainDatasetDonationDate.AfterLoadDFMValues;
    MainDatasetGiftAid.AfterLoadDFMValues;
    MainDatasetAmount.AfterLoadDFMValues;
    MainDatasetExternalDonationId.AfterLoadDFMValues;
    MainDatasetMatchedPerson.AfterLoadDFMValues;
    MainDatasetExternalDonationId2.AfterLoadDFMValues;
    MainDataSource.AfterLoadDFMValues;
    WebElementActionList1.AfterLoadDFMValues;
    ListCloseTimer.AfterLoadDFMValues;
    RefreshTimer.AfterLoadDFMValues;
    WaitForBatchIdTimer.AfterLoadDFMValues;
    WaitForBatchDataTimer.AfterLoadDFMValues;
    NextRecordTimer.AfterLoadDFMValues;
    EnableSaveButtonTimer.AfterLoadDFMValues;
  end;
end;

end.

